/* eslint-disable complexity */
import { Layout, Flex, Box, Text, useLocalVariant } from "@draftkings/arena-web";
import * as React from "react";
import { FinalScore } from "../FinalScore";
import { InelligibleForBonusBadge } from "../InelligibleForBonusBadge";
import { getSelectionSubtitleVariantStyles } from "./getSelectionSubtitleVariantStyles";
import { getSelectionTitleVariantStyles } from "./getSelectionTitleVariantStyles";
import { SportsbookContext } from "../../contexts";
import { GhostLeg } from "../GhostLeg/GhostLeg";
import { Tag } from "../Tag";
export const SelectionCard = React.memo(function SelectionCard(props) {
    const { selectionId, purchaseId, selectionDisplayName, marketDisplayName, displayOdds, finalScore, marketBlurb, displayBoostInelligibleLabel, type, children, selectionCardVariant, isGhostLeg, tag } = props;
    const selectionSubtitleVariant = useLocalVariant("text", getSelectionSubtitleVariantStyles(type, displayBoostInelligibleLabel, finalScore, marketBlurb));
    const selectionTitleVariant = useLocalVariant("text", getSelectionTitleVariantStyles(marketDisplayName, type));
    const overflowHiddenVariant = useLocalVariant("layout", {
        $extendFromVariant: selectionCardVariant,
        root: {
            overflow: "hidden",
        }
    });
    const { dictionary } = React.useContext(SportsbookContext);
    return React.createElement(Layout, { variant: overflowHiddenVariant, testId: 'selection-card' },
        React.createElement(Flex, null,
            React.createElement(Text, { testId: `bet-selection-title-${selectionId}`, variant: selectionTitleVariant }, selectionDisplayName),
            displayOdds && React.createElement(Text, { testId: `bet-selection-displayOdds-${selectionId}`, variant: "betTitle" }, displayOdds)),
        marketDisplayName && React.createElement(Text, { testId: `bet-selection-subtitle-${selectionId}`, variant: selectionSubtitleVariant }, marketDisplayName),
        React.createElement(Flex, { gap: "8px" },
            isGhostLeg && React.createElement(GhostLeg, { label: dictionary.myBetsDictionary.GhostLeg }),
            tag && React.createElement(Tag, { tag: tag, testId: `tag-${selectionId}` })),
        displayBoostInelligibleLabel && React.createElement(InelligibleForBonusBadge, { dictionary: dictionary, testId: `inneligible-badge-${selectionId}` }),
        finalScore && React.createElement(FinalScore, { selectionId: selectionId, finalScore: finalScore, result: dictionary.myBetsDictionary.Result }),
        marketBlurb && React.createElement(Box, { testId: `bet-selection-market-blurb-${purchaseId}-${selectionId}`, marginBottom: "12px", color: "$gray400" }, marketBlurb.text),
        children);
});
//# sourceMappingURL=SelectionCard.js.map